module.exports = __webpack_public_path__ + "static/media/rf1.e972a790.jpeg";